import { Grid, Typography } from '@mui/material';
import AuthContext from 'context/AuthContext';
import { useContext, useEffect } from 'react';
import { parseJwt } from 'utils';

const Home = () => {
  let { idToken, setFullName, setUserID, username, setUserName } = useContext(AuthContext);

  useEffect(async () => {
    const parsedToken = parseJwt(idToken);
    let { name, given_name, family_name } = parsedToken;
    const userId = parsedToken?.['cognito:username'];

    if (name) {
      setUserName(name);
    }
    if (given_name && family_name) {
      setFullName(`${given_name} ${family_name}`);
    }
    if (userId) {
      setUserID(userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="h4">
        Welcome,
        <Typography variant="span" color="primary">
          {username}
        </Typography>
      </Typography>
    </Grid>
  );
};

export default Home;
